import { slug } from "../../lib/format";

export const REQUIRED_FIELDS = [
  { key: "Loan ID", label: "ID crédito", kind: "text" },
  { key: "Loan Amount", label: "Monto del crédito", kind: "number" },
  { key: "Disbursement Date", label: "Fecha de disposición", kind: "date" },
];

export const OPTIONAL_FIELDS = [
  { key: "Product type", label: "Tipo de producto", kind: "text" },
  { key: "Loan Grade", label: "Calificación del crédito", kind: "text" },
  { key: "Credit Bureau Score", label: "Score de buró de crédito", kind: "number" },
  { key: "Internal Score", label: "Score interno", kind: "number" },
  { key: "Currency", label: "Moneda", kind: "text" },
  { key: "Origination Fee", label: "Comisión por apertura", kind: "number" },
  { key: "Effective Interest Rate", label: "Tasa de interés efectiva (%)", kind: "percent" },
  { key: "Term", label: "Plazo", kind: "number" },
  { key: "Term Unit", label: "Unidad de plazo (M = meses)", kind: "text" },
  { key: "Loan Type", label: "Tipo de crédito", kind: "text" },
  { key: "LoanNumber", label: "Número de crédito", kind: "number" },
  { key: "Originator Agent", label: "Agente originador", kind: "text" },
  { key: "Lender", label: "Otorgante", kind: "text" },
  { key: "Loan Use", label: "Destino del crédito", kind: "text" },
  { key: "Restructure from loan ID", label: "Reestructura del crédito", kind: "text" },
  { key: "Restructure to Loan ID", label: "Reestructurado en el crédito", kind: "text" },
  { key: "Refinanced from loan ID", label: "Refinanciamiento del crédito", kind: "text" },
  { key: "Refinanced to Loan ID", label: "Refinanciado en el crédito", kind: "text" },
];

export const DEFAULT_VALUES = { Currency: "MXN", "Term Unit": "M" };

export const LoanField = ({ field, value, error, onChange, required }) => {
  const id = slug(field.key);
  const type = field.kind === "date" ? "date" : field.kind === "text" ? "text" : "number";
  return (
    <label className="block min-w-0">
      <span className="tr-label">{field.label}{required && <span className="text-[#b42318]"> *</span>}</span>
      <input
        type={type}
        step={type === "number" ? "any" : undefined}
        value={value ?? ""}
        onChange={(e) => onChange(field.key, e.target.value)}
        className={`tr-input ${error ? "border-[#f3a9a9] focus:border-[#b42318] focus:ring-[#fdd]" : ""}`}
        data-testid={`loan-field-${id}`}
      />
      {error && <p className="tr-field-error" data-testid={`error-${id}`}>{error}</p>}
    </label>
  );
};
